import axios from 'axios';
import config from './config';
import { appLocalStorage } from './storage';

export const languageNames = { en: 'English (US)', ru: 'Русский', es: 'Español', fr: 'Français', ja: '日本語', ko: '한국어', pt: 'Português', tr: 'Türkçe', zh: '中文', de: 'Deutsch', it: 'Italiano', hi: 'हिन्दी' };
export const validLanguage = value => Object.prototype.hasOwnProperty.call(languageNames, value);
export function readPreferredLanguage() {
  try { const value = appLocalStorage.getItem('wiw.preferred-language'); return validLanguage(value) ? value : null; }
  catch { return null; }
}
export function rememberLanguage(language) {
  if (!validLanguage(language)) return;
  appLocalStorage.setItem('i18nextLng', language);
  appLocalStorage.setItem('wiw.preferred-language', language);
}
export async function persistAccountLanguage(token, id, language, signal) {
  if (!validLanguage(language) || !Number.isSafeInteger(id) || id <= 0 || !token) throw new Error('Invalid language preference');
  const result = await axios.put(`${(process.env.REACT_APP_API_URL || '').replace(/\/$/, '')}/user/${id}`,
    { id, lng_code: language }, { headers: { [config.token]: token, [config.lng]: language }, signal, timeout: 15000 });
  if (!result.data?.success) throw new Error('Language could not be saved');
}
